var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoorBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_8400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_8400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 17.5C3.09722 17.5 2.89931 17.4201 2.73958 17.2604C2.57986 17.1007 2.5 16.9028 2.5 16.6667C2.5 16.4306 2.57986 16.2326 2.73958 16.0729C2.89931 15.9132 3.09722 15.8333 3.33333 15.8333H4.16667V4.16667C4.16667 3.70833 4.32986 3.31597 4.65625 2.98958C4.98264 2.66319 5.375 2.5 5.83333 2.5H14.1667C14.625 2.5 15.0174 2.66319 15.3438 2.98958C15.6701 3.31597 15.8333 3.70833 15.8333 4.16667V15.8333H16.6667C16.9028 15.8333 17.1007 15.9132 17.2604 16.0729C17.4201 16.2326 17.5 16.4306 17.5 16.6667C17.5 16.9028 17.4201 17.1007 17.2604 17.2604C17.1007 17.4201 16.9028 17.5 16.6667 17.5H3.33333ZM8.33333 10.8333C8.56944 10.8333 8.76736 10.7535 8.92708 10.5938C9.08681 10.434 9.16667 10.2361 9.16667 10C9.16667 9.76389 9.08681 9.56597 8.92708 9.40625C8.76736 9.24653 8.56944 9.16667 8.33333 9.16667C8.09722 9.16667 7.89931 9.24653 7.73958 9.40625C7.57986 9.56597 7.5 9.76389 7.5 10C7.5 10.2361 7.57986 10.434 7.73958 10.5938C7.89931 10.7535 8.09722 10.8333 8.33333 10.8333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoorBack);
export default __webpack_public_path__ + "static/media/icon_door_back.6e3696048e160de10f0654acbb740cec.svg";
export { ForwardRef as ReactComponent };